import "../../styles/company/company.scss";
import "../../styles/users/profile.scss"

function toggleExpand(member) {
    const members = /** @type {NodeListOf<HTMLDivElement>} */ (document.querySelectorAll('.member'));
    const members_expanded = /** @type {NodeListOf<HTMLDivElement>} */ (document.querySelectorAll('.member-expanded'));
    const member_expanded = /** @type {HTMLDivElement} */ (document.querySelector(`.member-expanded[data-team="${member.dataset.team}"][data-id="${member.dataset.id}"]`));

    if (member.classList.contains('member-active')) {
        member.classList.remove('member-active');
        member_expanded.style.display = 'none';
    } else {
        // First clear all currently expanded member's profiles
        members.forEach(member => {
            member.classList.remove('member-active');
        });
        members_expanded.forEach(member_expanded => {
            member_expanded.style.display = 'none';
        });

        member.classList.add('member-active');
        member_expanded.style.display = 'block';

        // Responsively adjust the ordering of the expanded member profile so that it
        // always goes under the current row no matter the number of members per row
        const columns = Math.round(member.parentElement.offsetWidth / member.offsetWidth);
        const order = parseInt(member_expanded.dataset.order);
        if (columns == 2) { // 2 column layout set by css
            if (order % 2 == 1) {
                member_expanded.style.order = (order + 2).toString();
            } else {
                member_expanded.style.order = (order + 1).toString();
            }
        } else { // 3 column layout set by css
            if (order % 3 == 1) {
                member_expanded.style.order = (order + 3).toString();
            } else if (order % 3 == 2) {
                member_expanded.style.order = (order + 2).toString();
            } else {
                member_expanded.style.order = (order + 1).toString();
            }
        }
    }
}

document.addEventListener('click', (e) => {
    const element = /** @type {HTMLElement} */ (e.target);

    // Team
    if (element.classList.contains('member')) {
        toggleExpand(element);
    } else if (element.closest('.member') != null) {
        toggleExpand(element.closest('.member'));
    }
    // Contact
    else if (element.id == 'js-estab-contact-link') {
        e.preventDefault();
        const estabContactBlurb = document.querySelector('#js-estab-contact-blurb');
        const estabContactDetails = document.querySelector('#js-estab-contact-details');

        estabContactBlurb.classList.add('d-none');
        estabContactDetails.classList.remove('d-none');
    }
    // Careers
    else if (element.classList.contains('js-job-title-heading')) {
        element.querySelector('svg').classList.toggle('fa-chevron-down');
        element.querySelector('svg').classList.toggle('fa-chevron-up');
        element.nextElementSibling.classList.toggle('d-none');
    }
});

// Resizing browser window while member's profile is expaned breaks layout
// so collapse all expanded profiles on browser resize
window.addEventListener('resize', function () {
    const members = /** @type {NodeListOf<HTMLDivElement>} */ (document.querySelectorAll('.member'));
    const members_expanded = /** @type {NodeListOf<HTMLDivElement>} */ (document.querySelectorAll('.member-expanded'));

    members.forEach(member => {
        member.classList.remove('member-active');
    });
    members_expanded.forEach(member_expanded => {
        member_expanded.style.display = 'none';
    });
});
